module.exports = __webpack_public_path__ + "static/team5-7ca88e788444f7fe59a4e70acff3add6.jpg";